import { Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'

const Bank = types.model('Bank', {
  id: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  accountNumber: types.optional(types.string, ''),
  logo: types.optional(types.string, ''),
  isPopular: types.optional(types.boolean, false),
  rank: types.optional(types.number, 0),
  paymentType: types.optional(types.string, 'Bank'),
  isSelected: types.optional(types.boolean, false),
  type: types.optional(types.string, ''),
  key: types.optional(types.string, ''),
  value: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
})

export type BankType = Instance<typeof Bank>
export { Bank }
